export const capabilities = [
  {
    id: '01',
    title: 'Web Design',
    href: '/services/web-design',
    description:
      'Beautiful, modern websites that engage your audience and reflect your brand values.',
    services: [
      'Marketing & brochure sites',
      'Responsive UI design',
      'Content structure & wireframes',
      'Design systems',
      'Accessibility-focused layouts',
    ],
  },
  {
    id: '02',
    title: 'Development',
    href: '/services/web-design',
    description:
      'Production websites, dashboards, and integrations - maintainable code you can hand off or grow with.',
    services: [
      'React & Next.js frontends',
      'Firebase & cloud backends',
      'API integrations',
      'Performance optimization',
      'Deployment & hosting',
    ],
  },
  {
    id: '03',
    title: 'Custom Software',
    href: '/services/custom-software',
    description:
      'Line-of-business tools built for your workflows: POS, booking, CRM, invoicing, and admin systems your staff actually use.',
    services: [
      'POS & retail systems',
      'Booking & scheduling',
      'CRM & client portals',
      'Invoicing & payments',
      'Internal dashboards',
    ],
  },
  {
    id: '04',
    title: 'Brand Strategy',
    href: '/services/graphic-design',
    description: 'Strategic brand development to establish strong market positioning.',
    services: [
      'Positioning workshops',
      'Visual identity direction',
      'Messaging & tone',
      'Go-to-market support',
      'Brand guidelines',
    ],
  },
  {
    id: '05',
    title: 'SEO & Marketing',
    description: 'Data-driven strategies to grow your online presence.',
    services: [
      'Technical SEO',
      'On-page optimization',
      'Analytics setup',
      'Conversion tracking',
      'Content recommendations',
    ],
  },
  {
    id: '06',
    title: 'UX Consulting',
    description: 'Expert guidance on user experience and digital transformation.',
    services: [
      'UX audits',
      'User flows & journeys',
      'Prototype testing',
      'Accessibility reviews',
      'Product strategy',
    ],
  },
  {
    id: '07',
    title: 'Performance',
    description: 'Optimization for speed, security, and user satisfaction.',
    services: [
      'Core Web Vitals',
      'Bundle & load analysis',
      'Caching & CDN',
      'Security hardening',
      'Monitoring setup',
    ],
  },
] as const

export const servicePackages = [
  {
    name: 'Starter',
    price: 1999,
    description: 'Perfect for small businesses starting their digital journey',
    features: [
      'Responsive website (up to 5 pages)',
      'Modern design',
      'Basic SEO',
      'Contact form',
      'Mobile optimized',
      '1 month support',
    ],
  },
  {
    name: 'Professional',
    price: 4999,
    description: 'For growing businesses with complex needs',
    features: [
      'Custom website (up to 15 pages)',
      'Advanced SEO',
      'Blog/CMS',
      'Analytics setup',
      'Social media integration',
      '3 months support',
      'Performance optimization',
    ],
    featured: true,
  },
  {
    name: 'Enterprise',
    price: null as number | null,
    description: 'Custom solutions for larger organizations',
    features: [
      'Fully custom development',
      'Advanced features',
      'E-commerce setup',
      'Ongoing optimization',
      'Dedicated manager',
      'Long-term support',
    ],
  },
] as const
